export default __webpack_public_path__ + "/dist/images/fda-logo.svg";